module.exports = __webpack_public_path__ + "img/invites-empty-state.c2d7b46a.svg";